<template>
  <div class="mobile-cta-section" v-if="site !== 'courses'">
    <md-filled-tonal-button
      class="get-started-button"
      @click="$router.push('/try-comligo-for-free')"
    >
      Book Your Free Trial Now
      <i class="mdi mdi-arrow-right"></i>
    </md-filled-tonal-button>
  </div>
</template>

<script>
export default {
  name: "mobileCTA",
  data() {
    return {
      site: "main",
      url: "",
    };
  },
  mounted() {
    if (process?.env?.VUE_APP_SITE) {
      this.site = process?.env?.VUE_APP_SITE;
    }
    this.url = window?.location?.host;
  },
};
</script>

<style></style>
